import TextField from '@mui/material/TextField';
import {useField} from 'formik';
import React from 'react';

/**
 * Formik textfield wrapper
 * @param props
 */
const MyTextField: React.FC<any> = (props: any) => {
  const [field, meta] = useField(props);
  const errorText = meta.error && meta.touched ? meta.error : '';
  return (
    <TextField
      {...props}
      {...field}
      helperText={errorText}
      error={!!errorText}
      variant={props.variant ? props.variant : 'standard'}
      sx={
        props.required && {
          '& .MuiFormLabel-asterisk, & .MuiInputLabel-asterisk': {
            color: 'error.main',
          },
        }
      }
    />
  );
};
export default MyTextField;
